module.exports = __webpack_public_path__ + "static/pic-2-c7a713ea6beb4a086b295d33fe0f54ce.png";